<template>
  <v-card v-if="!loading" :loading="loading" flat class="pa-0 ma-0">
    <div class="tocs_gray_1 mt-2">
      <v-text-field
        v-model="search"
        append-icon="mdi-search"
        label="buscar"
        clearable
        single-line
        solo
        flat
        outlined
        dense
        hide-details
        class=""
      ></v-text-field>
    </div>

    <div style="height: calc(100vh - 345px); overflow-y: auto">
      <v-treeview
        :active.sync="active"
        :open.sync="open"
        :items="permissoes"
        :search="search.length >= 3 ? search : ''"
        item-text="descricao"
        item-key="id"
        item-children="children"
        transition
        activatable
        color="primary"
        @update:active="getPermissao()"
        hoverable
      >
        <template v-slot:prepend="{ item, open }">
          <v-icon>
            {{ open ? "mdi-folder-open" : "mdi-folder" }}
          </v-icon>
        </template>
        <template v-slot:label="{ item }">
          <div class="text-body-2">{{ item.descricao }}</div>
        </template>
      </v-treeview>
    </div>

    <v-dialog v-model="dialog" max-width="400px">
      <!-- :disabled="!vueUsuarioPermissoesEdit" -->
      <v-card flat>
        <v-card-title class="text-subtitle-1 lightgray">
          {{ permissao.descricao }}
          <v-spacer></v-spacer>
          <v-btn icon @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <!-- <v-card-text class="mt-4">
          {{ permissao.descricao_detalhe }}
        </v-card-text> -->
        <v-card-text class="pa-4" v-if="checkTotalPermissoes(permissao.bits)">
          <v-card
            flat
            class="d-flex aling-center justify-space-between my-2 px-4 py-2"
            color="lightgray"
            v-if="checkVisualizar(permissao.bits)"
          >
            <v-subheader
              style="height: auto !important"
              class="ma-0 pa-0 text-body-2 font-weight-medium text-uppercase"
            >
              Visualizar
            </v-subheader>

            <v-switch
              class="ma-0"
              hide-details
              :false-value="0"
              :true-value="1"
              v-model="bitWise.visualizar"
            ></v-switch>
          </v-card>

          <v-card
            flat
            class="d-flex aling-center justify-space-between my-2 px-4 py-2"
            color="lightgray"
            v-if="checkAdicionar(permissao.bits)"
          >
            <v-subheader
              style="height: auto !important"
              class="ma-0 pa-0 text-body-2 font-weight-medium text-uppercase"
            >
              Adicionar
            </v-subheader>

            <v-switch
              class="ma-0"
              hide-details
              :false-value="0"
              :true-value="2"
              v-model="bitWise.adicionar"
            ></v-switch>
          </v-card>

          <v-card
            flat
            class="d-flex aling-center justify-space-between my-2 px-4 py-2"
            color="lightgray"
            v-if="checkEditar(permissao.bits)"
          >
            <v-subheader
              style="height: auto !important"
              class="ma-0 pa-0 text-body-2 font-weight-medium text-uppercase"
            >
              Editar
            </v-subheader>

            <v-switch
              class="ma-0"
              hide-details
              :false-value="0"
              :true-value="4"
              v-model="bitWise.editar"
            ></v-switch>
          </v-card>

          <v-card
            flat
            class="d-flex aling-center justify-space-between my-2 px-4 py-2"
            color="lightgray"
            v-if="checkDeletar(permissao.bits)"
          >
            <v-subheader
              style="height: auto !important"
              class="ma-0 pa-0 text-body-2 font-weight-medium text-uppercase"
            >
              Deletar
            </v-subheader>

            <v-switch
              class="ma-0"
              hide-details
              :false-value="0"
              :true-value="8"
              v-model="bitWise.deletar"
            ></v-switch>
          </v-card>

          <v-card
            flat
            class="d-flex aling-center justify-space-between my-2 px-4 py-2"
            color="lightgray"
            v-if="checkImprimir(permissao.bits)"
          >
            <v-subheader
              style="height: auto !important"
              class="ma-0 pa-0 text-body-2 font-weight-medium text-uppercase"
            >
              Imprimir
            </v-subheader>

            <v-switch
              class="ma-0"
              hide-details
              :false-value="0"
              :true-value="16"
              v-model="bitWise.imprimir"
            ></v-switch>
          </v-card>

          <v-card
            flat
            class="d-flex aling-center justify-space-between my-2 px-4 py-2"
            color="lightgray"
            v-if="checkExportar(permissao.bits)"
          >
            <v-subheader
              style="height: auto !important"
              class="ma-0 pa-0 text-body-2 font-weight-medium text-uppercase"
            >
              Exportar
            </v-subheader>

            <v-switch
              class="ma-0"
              hide-details
              :false-value="0"
              :true-value="32"
              v-model="bitWise.exportar"
            ></v-switch>
          </v-card>

          <v-card
            class="d-flex align-center justify-space-between my-2 px-4 py-2"
            flat
            color="lightgray"
            v-if="checkImportar(permissao.bits)"
          >
            <v-subheader
              style="height: auto !important"
              class="ma-0 pa-0 text-body-2 font-weight-medium text-uppercase"
            >
              Importar
            </v-subheader>
            <v-switch
              class="ma-0"
              hide-details
              :false-value="0"
              :true-value="64"
              v-model="bitWise.importar"
            ></v-switch>
          </v-card>

          <v-card
            flat
            class="d-flex aling-center justify-space-between my-2 px-4 py-2"
            color="lightgray"
            v-if="checkLimitar(permissao.bits)"
          >
            <v-subheader
              style="height: auto !important"
              class="ma-0 pa-0 text-body-2 font-weight-medium text-uppercase"
            >
              Limitar
            </v-subheader>

            <v-switch
              class="ma-0"
              hide-details
              :false-value="0"
              :true-value="128"
              v-model="bitWise.limitar"
            ></v-switch>
          </v-card>
        </v-card-text>
        <v-scroll-y-transition mode="out-in">
          <v-card-text class="py-0 mb-6" v-if="bitWise.limitar">
            <v-row>
              <v-col>
                <v-text-field
                  v-model="userPermissao.valor"
                  label="Valor"
                  type="number"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col>
                <v-text-field
                  v-model="userPermissao.operador"
                  label="Operador"
                  outlined
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-scroll-y-transition>

        <v-card-actions class="pa-4">
          <v-spacer></v-spacer>
          <!-- v-if="vueUsuarioPermissoesEdit" -->
          <v-btn
            @click="updateUserPermission(userPermissao.id)"
            depressed
            dark
            small
            :loading="loadingButton"
            color="button_2"
          >
            salvar
            <v-icon>mdi-content-save</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
  <Carregando v-else />
</template>

<script>
import { getPermissao, getPermissoes } from "@/api/permissoes/permissoes.js";

import {
  getUsuarioPermissoes,
  putPermissaoUsuario,
  postPermissaoUsuario,
} from "@/api/permissoes/users_permissoes.js";

import { getAllUsuarios } from "@/api/usuarios/usuarios.js";
import updateBitMask from "@/mixins/configuracoes/permissoes/updateBitMask.js";
import checkPermissions from "@/mixins/configuracoes/permissoes/checkPermissions.js";
// import copyUserPermissions from "@/mixins/configuracoes/permissoes/copyUserPermissions.js";

// import { mapGetters } from "vuex";

export default {
  name: "UsuarioPermissoes",
  mixins: [updateBitMask, checkPermissions],
  props: {
    usuarioId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      loadingButton: false,
      loading: true,
      search: "",
      dialog: false,
      active: [],
      open: [],
      valid: false,
      permissoes: [],
      permissao: {
        bits: 0,
      },
      bitWise: {
        visualizar: 0,
        criar: 0,
        editar: 0,
        deletar: 0,
        imprimir: 0,
        exportar: 0,
        limitar: 0,
      },
      original: {},
      userPermissoes: [],
      copiaUserPermissoes: [],
      userPermissao: {
        bits: 0,
      },
      usuarios: [],
      selectedUserId: null,
    };
  },

  computed: {
    userId() {
      return this.usuarioId;
    },
  },
  methods: {
    goToPermissao(item) {
      this.$router.push({
        name: "Permissao",
        params: { permissaoId: item },
      });
    },
    getPermissaoPai(permissao_id) {
      let permissao_pai = "";
      this.permissoes.forEach((permissao) => {
        if (permissao.id == permissao_id) {
          permissao_pai = ". " + permissao.descricao;
        }
      });
      return permissao_pai;
    },
    getPermissao() {
      this.bitWise.visualizar = 0;
      this.bitWise.adicionar = 0;
      this.bitWise.editar = 0;
      this.bitWise.deletar = 0;
      this.bitWise.imprimir = 0;
      this.bitWise.exportar = 0;
      this.bitWise.importar = 0;
      this.bitWise.limitar = 0;

      this.userPermissao = {};

      if (this.active[0]) {
        getPermissao(this.active[0])
          .then((response) => {
            this.permissao = response;
            this.dialog = true;
          })
          .catch((error) => {
            if (error.response.status === 404) {
              this.$toast.error(
                this.$tc("configuracoes.permissaonaoencontrada")
              );
            }
            console.error(error);
          });

        this.userPermissoes.forEach((permissao) => {
          if (this.active[0] === permissao.permissao_id) {
            this.userPermissao = permissao;
            this.updateBitMasks(this.userPermissao.bits);
            this.original = { ...permissao };
          }
        });
      }
    },
    fetchUsuarioPermissoes(userId) {
      if (userId) {
        return getUsuarioPermissoes(userId)
          .then((response) => {
            this.userPermissoes = response;
          })
          .catch((error) => {
            if (error.response.status === 404) {
              this.notFound = "Permissao nao Econtrada";
            }
            console.error(error);
          });
      }
    },
    updateUserPermission(id) {
      this.loadingButton = true;
      this.userPermissao.bits =
        this.bitWise.visualizar +
        this.bitWise.adicionar +
        this.bitWise.editar +
        this.bitWise.deletar +
        this.bitWise.imprimir +
        this.bitWise.exportar +
        this.bitWise.importar +
        this.bitWise.limitar;

      let permIgual = this.userPermissoes.find(
        (perm) => perm.permissao_id === this.permissao.id
      );

      if (permIgual) {
        if (
          JSON.stringify(this.userPermissao) == JSON.stringify(this.original)
        ) {
          this.$toast.error("Por favor, faça uma mudança antes de atualizar!");
          this.loadingButton = false;
        } else {
          putPermissaoUsuario(id, this.userPermissao)
            .then((response) => {
              if (response.status === 201) {
                this.$toast.success("Atualizado com sucesso!");
                this.original = { ...this.userPermissao };
                this.fetchUsuarioPermissoes(this.userId);
                this.loadingButton = false;
                this.dialog = false;
              }
            })
            .catch((error) => {
              this.loadingButton = false;
            });
        }
      } else {
        postPermissaoUsuario(this.userPermissao, this.userId, this.permissao.id)
          .then((response) => {
            if (response.status === 201) {
              this.$toast.success("Criado Sucesso");
              this.original = { ...this.userPermissao }; //
              this.fetchUsuarioPermissoes(this.userId);
              this.loadingButton = false;
              this.dialog = false;
            }
          })
          .catch((error) => {
            if (error.response.status === 422) {
              this.$toast.error("Alteração salva");
            }
            this.loadingButton = false;
          });
      }
    },
  },
  async mounted() {
    this.loading = true;
    // Pega todas as permissoes existentes
    await getPermissoes()
      .then((response) => {
        this.permissoes = response;
        this.permissoes.forEach((permissao) => {
          this.open.push(permissao.id);
          permissao.children.forEach((child) => {
            this.open.push(child.id);
          });
        });
      })
      .catch((error) => {
        console.error(error);
      });

    // Todas as permissoes do USUARIO

    await this.fetchUsuarioPermissoes(this.userId);

    // Todos os usuarios
    await getAllUsuarios()
      .then((response) => {
        this.usuarios = response;
        let removeIndex = this.usuarios
          .map((item) => item.id)
          .indexOf(this.userId);
        this.usuarios.splice(removeIndex, 1);
      })
      .catch((error) => {});
    this.loading = false;
  },
};
</script>

<style scoped lang="scss">
::v-deep .v-treeview-node {
  cursor: pointer;
  // background: #f9f9f9;
  margin: 10px 0;
  border-radius: 4px;
  // border: thin solid rgba(0, 0, 0, 0.08);

  .v-treeview-node__children {
    .v-treeview-node {
      border-top: none;
      border-left: none;
      border-right: none;
      border-bottom: thin solid rgba(0, 0, 0, 0.08);
      border-radius: 0px;
      margin: 0;

      &:first-of-type {
        border-top: thin solid rgba(0, 0, 0, 0.08);
      }
      &:last-of-type {
        border-bottom: none;
      }
    }
  }
}
</style>
